module.exports = __webpack_public_path__ + "img/js-1.8bf39f2d.jpg";